import * as yup from 'yup'

const defaultRequiredMessage = 'Email inválido'

yup.setLocale({
  mixed: {
    required: defaultRequiredMessage
  }
})

export const validationSchema = yup.object().shape({
  email: yup.string().trim().required()
})
